import { Alert, Typography } from "@mui/material";
import { rem } from "polished";
import React from "react";
import { useParams } from "react-router-dom";

import { type AccountPageParams } from "src/constants";
import { TicketCategoryEnum, TicketHeadingCategoryEnum } from "src/graphql/generated/types";
import { useMyLogin } from "src/hooks";
import { useBrand } from "src/hooks/useBrand";
import { CreateTicket } from "src/pages/_shared/CreateTicket";
import { notUndefined } from "src/utils";
import { isActivationKey } from "src/utils/activationKey";

const CredentialsModificationInfo = () => {
  const params = useParams<AccountPageParams>();
  const accountUuid = notUndefined(params.uuid);
  const login = useMyLogin();
  const { customerPortal } = useBrand();

  return (
    <Alert role="status" severity="info" color="warning" sx={{ mt: 2, mb: 4 }}>
      <Typography>
        Afin de valider votre changement de mot de passe, un email de validation va vous être envoyé
        sur votre adresse mail de connexion {customerPortal.name} : {login}
        <br />
        Si vous ne pouvez pas accéder à ce mail, veuillez cliquer{" "}
        <CreateTicket
          uuid={accountUuid}
          preselectedCategory={{
            headingCategory: TicketHeadingCategoryEnum.LandlordDocuments,
            category: TicketCategoryEnum.LandlordDocumentsContacts,
          }}
          renderButton={({ handleOpen }) => (
            <Typography
              sx={{ textDecoration: "underline", cursor: "pointer", fontSize: rem(16) }}
              display="inline"
              tabIndex={0}
              onKeyDown={(e) => {
                if (isActivationKey(e)) {
                  handleOpen();
                }
              }}
              role="button"
              onClick={handleOpen}
            >
              ici
            </Typography>
          )}
        />
      </Typography>
    </Alert>
  );
};

export default CredentialsModificationInfo;
